
import { Options, Vue } from 'vue-class-component'
import { mapState, mapMutations } from 'vuex'
import BaseComponent from '@/components/Base.vue'
import DialogComponent from '@/components/Dialog.vue'
import Tricube from '@/components/Tricube.vue'

import Moment from 'moment'
import COVERAPP from '@/utils/COVERAPP'
import 'animate.css';

@Options({
    data () {
        return {
            isApp: false
        }
    },
    created () {
        this.getActDetail()
    },
    watch: {
        $route (to, from) {
            if (to.fullPath != from.fullPath) {
                this.SET_DIALOGDATA(null)
                this.$common.pageLoading()
            }
        }
    },
    computed: {
        ...mapState(['aid', 'userInfo', 'shareData', 'dialogData', 'activityData'])
    },
    components: {
        BaseComponent,
        DialogComponent,
        Tricube,
    },
    mounted () {
        this.isApp = COVERAPP.Attribute.isApp()
        window.addEventListener('pageshow', (e) => {
            if (e.persisted) {
                window.location.reload()
            }
        })
    },
    methods: {
        ...mapMutations(['SET_USERINFO', 'SET_SHAREDATA', 'SET_DIALOGDATA' , 'SET_ACTIVITYDATA']),
        getActDetail (): void {
            this.$request('/activity/config', {
                aid: this.aid
            }).then((data: any) => {
                // 设置分享信息
                data.share && this.setShareData(data)
                // 设置活动数据
                this.SET_ACTIVITYDATA(data)
                // 判断活动是否开始
                this.activityStatus(data)
            })
        },
        activityStatus (data: any) {
            if (new Date(data.serverTime).getTime() < new Date(data.startTime).getTime()) {
                this.SET_DIALOGDATA({
                    text: `活动尚未开启，请在${Moment(data.startTime).format('YYYY.MM.DD')}—${Moment(data.endTime).format('YYYY.MM.DD')}时间段内来参与！`
                })
            } else if (new Date(data.serverTime).getTime() > new Date(data.endTime).getTime()) {
                this.SET_DIALOGDATA({
                    text: '您来晚了，本活动已经结束'
                })
            } else if (!this.isApp && data.isAppShow) {
                this.SET_DIALOGDATA({
                    text: '参加该活动需在封面新闻APP中进行',
                    btns: [
                        {
                            text: '取消',
                            className : 'cancel-btn'
                        },
                        {
                            text: '确定',
                            className : 'download-btn'
                        }
                    ]
                })
            }
        },
        setShareData (data: any) {
            this.SET_SHAREDATA({
                title: data.share.title,
                desc: data.share.desc,
                imgUrl: data.share.imgUrl || 'https://wapcdn.thecover.cn/cdn/wap/img/fengmian_logo.png',
                link: window.location.href
            })
        }
    }
})
export default class App extends Vue {}
